import { EventsQuery, LocationsFragment, Maybe } from '../generated/graphql';

const removeEventTypename = (events?: Maybe<EventsQuery['events']>) => {
  // Remove from location
  const cleanLocation = (location?: Maybe<LocationsFragment>): Omit<LocationsFragment, '__typename'> | null => {
    let clean = null;
    if (location) {
      const { __typename, ...l } = location;
      clean = l;
    }

    return clean;
  };

  // Remove __typename from events. defaulting to null like gql query
  return events?.map(({ __typename, questions = null, subEvents = null, location = null, ...e }) => {
    // Remove from questions and options
    let cleanQuestions = null;
    if (questions && questions.length) {
      cleanQuestions = questions?.map(({ __typename, ...q }) => {
        let question = q;
        if (q.options) {
          question.options = q.options.map(({ __typename, ...o }) => o);
        }

        return question;
      });
    }

    // Remove from subEvents
    let cleanSubEvents = null;
    if (subEvents && subEvents.length) {
      cleanSubEvents = subEvents.map(({ __typename, ...s }) => {
        return {
          ...s,
          location: cleanLocation(s.location),
        };
      });
    }

    return { ...e, questions: cleanQuestions, subEvents: cleanSubEvents, location: cleanLocation(location) };
  });
};

export default removeEventTypename;
